/**
 * ECO Haustechnik — Referenz-Projekte Konfiguration
 *
 * Platzhalter-Projekte für den Galerie-Slider und die Detail-Steckbriefseiten.
 * Bitte durch echte, freigegebene Projekte ersetzen (Fotos der eigenen Umsetzungen).
 *
 * Jedes Element:
 *   - slug:        URL-Fragment für /projekte/<slug>
 *   - image:       Hauptbild
 *   - gallery:     Weitere Bilder für die Steckbriefseite (3-6 empfohlen)
 *   - phase:       Projektphase als Chip
 *   - title:       Projekttitel
 *   - subtitle:    Kurze Beschreibung (Galerie-Slider)
 *   - description: Längere Beschreibung (Steckbriefseite)
 *   - highlights:  Bullet-Punkte für die Detail-Seite
 *   - meta:        [{ label, value }] bis zu 4 Kennzahlen
 *   - tags:        [string] technische Bereiche
 */

export const REFERENCE_PROJECTS = [
  {
    slug: "bim-planung-efh",
    image: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1920&q=85",
    gallery: [
      "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1920&q=85",
      "https://images.unsplash.com/photo-1581094271901-8022df4466f9?auto=format&fit=crop&w=1920&q=85",
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1920&q=85",
      "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=1920&q=85",
    ],
    phase: "BIM-Planung",
    title: "Technische Planung Einfamilienhaus",
    subtitle: "Von der Bestandsaufnahme bis zum koordinierten BIM-Modell — Heizung, Elektro und Automation in einem Modell.",
    description: "Das Projekt startete mit einer sauberen Bestandsaufnahme und einer detaillierten Bedarfsermittlung. Heizlast, Warmwasserbedarf und spätere Automationsszenarien wurden früh definiert, bevor erste Leitungen gezogen wurden. Im BIM-Modell wurden Heizkreisverteiler, PV-Vorbereitung und Elektroverteiler übereinandergelegt — so wurden Schnittstellen sichtbar, bevor sie auf der Baustelle zum Problem geworden wären.",
    highlights: [
      "Bestandsaufnahme, Heizlast- und Warmwasserbedarf-Berechnung",
      "BIM-Modell mit Heizung, Elektro, Lüftung und Automation",
      "Kollisionsprüfung Leitungen vs. Deckendurchbrüche",
      "Technikraum-Layout mit Wartungszugängen",
    ],
    meta: [
      { label: "Objekt", value: "EFH, Neubau" },
      { label: "Fläche", value: "ca. 180 m²" },
      { label: "Phase", value: "Vorplanung / BIM" },
      { label: "Dauer", value: "4 Wochen" },
    ],
    tags: ["BIM", "Planung", "Heizung", "Elektro"],
  },
  {
    slug: "waermepumpe-technikraum",
    image: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?auto=format&fit=crop&w=1920&q=85",
    gallery: [
      "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?auto=format&fit=crop&w=1920&q=85",
      "https://images.unsplash.com/photo-1518709268805-4e9042af2176?auto=format&fit=crop&w=1920&q=85",
      "https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?auto=format&fit=crop&w=1920&q=85",
      "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1920&q=85",
    ],
    phase: "Technikraum",
    title: "Energie-Zentrale mit Wärmepumpe",
    subtitle: "Luft-Wasser-Wärmepumpe, Pufferspeicher, Warmwasserspeicher und PV-Wechselrichter in einem sauber geplanten Technikraum.",
    description: "Die Energie-Zentrale verbindet die Luft-Wasser-Wärmepumpe mit Pufferspeicher, Warmwasserspeicher und PV-Wechselrichter. Jede Komponente wurde so platziert, dass Serviceeingriffe ohne Umbau möglich sind. Die hydraulische Verrohrung wurde vorab geplant und dokumentiert — Druckverluste und Zonenregelung wurden projektabhängig ausgelegt.",
    highlights: [
      "Luft-Wasser-Wärmepumpe mit hydraulischer Weiche",
      "Pufferspeicher und Warmwasserspeicher getrennt dimensioniert",
      "PV-Wechselrichter mit Monitoring-Anbindung",
      "Dokumentation + Einschulung bei Übergabe",
    ],
    meta: [
      { label: "System", value: "Luft-WP + PV" },
      { label: "Speicher", value: "Puffer + WW" },
      { label: "Steuerung", value: "Zonen + App" },
      { label: "Montage", value: "2 Tage" },
    ],
    tags: ["Wärmepumpe", "Warmwasser", "PV", "Hydraulik"],
  },
  {
    slug: "wohnanlage-zentraltechnik",
    image: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=1920&q=85",
    gallery: [
      "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=1920&q=85",
      "https://images.unsplash.com/photo-1511818966892-d7d671e672a2?auto=format&fit=crop&w=1920&q=85",
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1920&q=85",
      "https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=1920&q=85",
    ],
    phase: "Fertigstellung",
    title: "Wohnanlage mit zentralem Energiekonzept",
    subtitle: "Zentraltechnik mit wohnungsweiser Regelung, Verbrauchserfassung und Monitoring für die Hausverwaltung.",
    description: "Für die Wohnanlage wurde ein zentrales Energiekonzept mit wohnungsweiser Regelung umgesetzt. Jede Wohnung hat ihre eigene Verbrauchsmessung, die zentrale Hausverwaltung bekommt eine Übersicht über alle Verbräuche und Betriebszustände. Allgemeinflächen, Zutritt und Türkommunikation wurden im selben System integriert.",
    highlights: [
      "Zentrale Heizzentrale mit wohnungsweiser Übergabe",
      "Verbrauchsmessung pro Wohneinheit (Wärme, Warmwasser, Strom)",
      "Monitoring-Dashboard für die Hausverwaltung",
      "Zutritt und Video-Türkommunikation integriert",
    ],
    meta: [
      { label: "Objekt", value: "Wohnanlage" },
      { label: "Einheiten", value: "12 Wohnungen" },
      { label: "Regelung", value: "wohnungsweise" },
      { label: "Monitoring", value: "zentral" },
    ],
    tags: ["Wohnanlage", "Zentraltechnik", "Monitoring"],
  },
  {
    slug: "gebaeudeautomation-visualisierung",
    image: "https://static.prod-images.emergentagent.com/jobs/6eeff79d-3898-4697-b107-96bb26575cb5/images/50e7c7662fac932dcbac2c6942797bccab5becb52757e41c67b51194747a46d5.jpeg",
    gallery: [
      "https://static.prod-images.emergentagent.com/jobs/6eeff79d-3898-4697-b107-96bb26575cb5/images/50e7c7662fac932dcbac2c6942797bccab5becb52757e41c67b51194747a46d5.jpeg",
      "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1920&q=85",
      "https://images.unsplash.com/photo-1484242857719-4b9144542727?auto=format&fit=crop&w=1920&q=85",
      "https://images.unsplash.com/photo-1540932239986-30128078f3c5?auto=format&fit=crop&w=1920&q=85",
    ],
    phase: "Automation",
    title: "Gebäudeautomation mit Visualisierung",
    subtitle: "Zentrale Steuerung für Heizung, Licht, Beschattung und Zutritt — mit App-Anbindung und Fernzugriff.",
    description: "Die Gebäudeautomation verbindet Heizung, Licht, Beschattung und Zutritt in einer gemeinsamen Visualisierung. Szenen für den Alltag (Morgen, Abend, Abwesenheit) wurden mit den Bewohnern erarbeitet und einprogrammiert. Der Fernzugriff erfolgt verschlüsselt über eine mobile App.",
    highlights: [
      "Bus-System für Heizung, Licht und Beschattung",
      "Funk-Ergänzung für Nachrüstbereiche",
      "App mit Szenen, Zeitprogrammen und Fernzugriff",
      "Nutzer-Einschulung mit Dokumentation",
    ],
    meta: [
      { label: "System", value: "Bus + Funk" },
      { label: "Bereiche", value: "Licht · Heizung · Zutritt" },
      { label: "App", value: "iOS + Android" },
      { label: "Fernzugriff", value: "Verschlüsselt" },
    ],
    tags: ["Automation", "Licht", "Beschattung", "Zutritt"],
  },
  {
    slug: "pv-speicher-eigenverbrauch",
    image: "https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?auto=format&fit=crop&w=1920&q=85",
    gallery: [
      "https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?auto=format&fit=crop&w=1920&q=85",
      "https://images.unsplash.com/photo-1509391366360-2e959784a276?auto=format&fit=crop&w=1920&q=85",
      "https://images.unsplash.com/photo-1466611653911-95081537e5b7?auto=format&fit=crop&w=1920&q=85",
      "https://images.unsplash.com/photo-1559302504-64aae6ca6b6d?auto=format&fit=crop&w=1920&q=85",
    ],
    phase: "PV & Speicher",
    title: "PV-Anlage mit Eigenverbrauchsoptimierung",
    subtitle: "Dach-PV mit Speicher und direkter Kopplung an Wärmepumpe und Hausverbrauch — gesteuert über Energiemanagement.",
    description: "Die PV-Anlage wurde auf die Dachausrichtung und den tatsächlichen Verbrauch des Gebäudes dimensioniert. Der Speicher gleicht den Überschuss aus, das Energiemanagement priorisiert Wärmepumpe und Hausverbrauch vor Netzeinspeisung. Betriebsdaten werden kontinuierlich protokolliert, Abweichungen führen zu einem Service-Alert.",
    highlights: [
      "Dachausrichtung + Verschattung projektabhängig geprüft",
      "Speicher als Lastausgleich und WP-Priorisierung",
      "Energiemanagement mit Verbrauchs-Visualisierung",
      "Betriebsdaten-Monitoring und Service-Alerts",
    ],
    meta: [
      { label: "PV-Leistung", value: "ca. 9 kWp" },
      { label: "Speicher", value: "10 kWh" },
      { label: "Kopplung", value: "WP + Haus" },
      { label: "Steuerung", value: "EMS" },
    ],
    tags: ["PV", "Speicher", "EMS", "Eigenverbrauch"],
  },
];

export const findProjectBySlug = (slug) =>
  REFERENCE_PROJECTS.find((p) => p.slug === slug);
